import { useIsNative } from '~/context/common/DeviceContext';

export function getClientId(isNative: boolean) {
  return isNative ? 'srp_webview' : 'srp_ui';
}

export default function useGetClientId() {
  const isNative = useIsNative();

  return getClientId(isNative);
}
